<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosRegisterLinksRecord"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item :label="t('operate.r1nt24')">
              <a-input v-model:value="queryForm.customerName" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('operate.qplb8j')">
              <a-input v-model:value="queryForm.contactInfo" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('operate.pitjjk')">
              <UserSelect v-model:value="queryForm.operator" allowClear />
            </dc-form-item>
            <dc-form-item :label="t('operate.2u7exp')">
              <cos-range-picker v-model:startTime="queryForm.start" v-model:endTime="queryForm.end" />
            </dc-form-item>
            <dc-form-item :label="t('operate.ta0eas')">
              <a-select ref="select" v-model:value="queryForm.type" allowClear :placeholder="t('common.pleaseSelect')">
                <a-select-option value="">{{ t('common.all') }}</a-select-option>
                <a-select-option :value="1">{{ t('operate.ck63zb') }}</a-select-option>
                <a-select-option :value="0">{{ t('operate.4ww2os') }}</a-select-option>
              </a-select>
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'type'">
            {{ [t('operate.4ww2os'), t('operate.ck63zb')][record.type] }}
          </template>
          <template v-if="column.dataIndex === 'result'">
            {{ [t('operate.jeiacs'), t('operate.vw3d2n'), t('operate.0lkk5n')][record.result] }}
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import { reactive, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { registerRecordPage, getRegisterDetail } from '@/api/overseasSales/businessRuleSetting'

export default { name: 'DcCosOFbuRegisterLinksRecord' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const tableRef = ref()
const queryForm = reactive({
  customerName: '',
  contactInfo: '',
  start: '',
  end: '',
  type: undefined
})
// 获取详情联系人信息
const showMask = (record: any, callBack: (res: any) => void) => {
  getRegisterDetail(record.id).then((res) => {
    const { contactInfo } = res.data
    callBack({ contactInfo })
  })
}
// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await registerRecordPage({ ...params })
  callBack(res)
}
const columns = computed(() => [
  { title: t('operate.r1nt24'), dataIndex: 'customerName' },
  { title: t('operate.ta0eas'), dataIndex: 'type' },
  {
    title: t('operate.qplb8j'),
    dataIndex: 'contactInfo',
    cosType: 'mask'
  },
  { title: t('operate.pitjjk'), dataIndex: 'operatorName' },
  { title: t('operate.2u7exp'), dataIndex: 'createTime' },
  { title: t('operate.qq3dmf'), dataIndex: 'result' }
])
</script>

<style scoped></style>
